// extracted by mini-css-extract-plugin
export default {"marginBottom":"cXl2dc2QOgwqwj_tCoxU"};